import React from "react";
import { Triangle } from "react-loader-spinner";

interface LoaderProps {
  visible: boolean;
  text?: string;
}

export const Loader: React.FC<LoaderProps> = ({ visible, text }) => {
  const defaultText = "در حال آماده سازی فایل، لطفا منتظر بمانید...";
  return visible ? (
    <div className="main-loader-container">
      <Triangle
        visible={visible || false}
        height="80"
        width="80"
        color="#ac2727"
        ariaLabel="triangle-loading"
        wrapperStyle={{}}
        wrapperClass="main-loader"
      />
      <div className="loader-helper">
        <p>{text || defaultText}</p>
      </div>
    </div>
  ) : (
    <></>
  );
};
